import React, { useEffect, useState } from 'react'
import { getTravelsDataApi } from '../../../Api/TaxiServices'
import Style from './TaxiFinishedRequest.module.css'
import TaxiFinishedTravelDetail from '../../../Component/TaxiFinishedTravelDetail/TaxiFinishedTravelDetail'
const TaxiFinishedRequest = () => {
  const[TravelsState,setTravelsState]=useState()
  useEffect(()=>{
    getTravelDataHandler()
  },[])
  const getTravelDataHandler=()=>{
    getTravelsDataApi((succ,res)=>{
      if(succ){
        if(res.staus===-1){
          console.log(res.message)
        }else{
          setTravelsState(res.travels)
        }
      }else{
        console.log(res)
      }
    })
  }
  return (
    <div className={Style.componentHolder}>
      {
        TravelsState===undefined?<p>درحال دریافت اطلاعات....</p>:TravelsState.length===0?<p>سفری یافت نشد!</p>:<TaxiFinishedTravelDetail data={TravelsState}/>
      }
    </div>
  )
}

export default TaxiFinishedRequest